import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import WorklistModal from "./WorklistModal";
import { fetchWorklistProgress } from "../../../services/managerWorkListService";
import localStorageStore from "../../../utils/localStorageStore";
import { getActivityLog } from "../../../services/managerService";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { userRole } from "../../../utils/constants";
import moment from "moment";

function WorklistDetailsActivity({
  setChangeInWorklist,
  worklistId,
  masterData,
  parentDetails,
  worklist,
  changeInWorklist,
}) {
  const [showModalBox, setShowModalBox] = useState(false);
  const [worklistRows, setWorklistRows] = useState();
  const [parentWorklist, setParentWorklist] = useState(false);
  const [currenTab, setCurrentTab] = useState("details");
  const [rangeWorklist, setRangeWorklist] = useState();
  const [activityLog, setActivityLog] = useState({});
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoading, setLoadingState] = useState(false);
  const [isAuditor, setAuditor] = useState(false);

  const fetchRecords = (worklistId) => {
    getActivityLog(worklistId).then((response) => {
      setActivityLog(response?.data);
    });
  };
  const handleActivityModal = () => {
    setShowModalBox(false);
  };

  useEffect(() => {}, [activityLog]);

  useEffect(() => {
    fetchRecords(worklistId);
  }, [changeInWorklist, location]);

  useEffect(() => {
    fetchRecords(worklistId);
  }, []);

  useEffect(() => {
    const currentUser = localStorage.getItem("RoleId");
    worklistRows?.forEach((item, index) => {
      item?.users?.forEach((user) => {
        if (user.id === currentUser) {
          setAuditor(true);
        }
      });
    });
  }, [worklistRows]);

  useEffect(() => {
    fetchWorklistData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parentWorklist, parentDetails, location]);

  const fetchWorklistData = async () => {
    setLoadingState(true);
    const res = await fetchWorklistProgress(worklistId);

    if (Array.isArray(res)) {
      setWorklistRows(res);
    }
    setLoadingState(false);
  };

  const handleParentWorklist = () => {
    if (parentWorklist === false) {
      setParentWorklist(true);
    } else if (parentWorklist === true) {
      setParentWorklist(false);
    }
  };

  const imageIdGenerate = (userId) => {
    let u_id = userId;
    if (u_id > 30) {
      return imageIdGenerate(u_id - 30);
    } else {
      return u_id;
    }
  };

  const handleRedirect = (range) => {
    localStorage.removeItem("valerion_filter_values");
    const filterValues = {
      worklist_id: worklistId,
      s_no_from: range.split("-")?.[0].trim(),
      s_no_to: range.split("-")?.[1].trim(),
      worklist_number: worklist,
      actualWorkList: [{ worklist_no: worklist, id: worklistId }],
    };
    localStorageStore.setFilterValues(JSON.stringify(filterValues));
    navigate("/");
  };

  return (
    <>
      <div className="col-xl-7">
        <div className="card priority-card pt-4 mb-6 mb-xl-9">
          <div className="card-header border-0 pb-2">
            <ul className="nav nav-tabs nav-line-tabs mb-0 fs-6" role="tablist">
              <li className="nav-item" role="presentation">
                <Link
                  className="nav-link active"
                  data-bs-toggle="tab"
                  aria-selected="true"
                  role="tab"
                  onClick={(e) => setCurrentTab("details")}
                >
                  Details
                </Link>
              </li>
              {localStorage.getItem("Role") !== userRole.Auditor ? (
                <li className="nav-item" role="presentation">
                  <Link
                    className="nav-link"
                    data-bs-toggle="tab"
                    aria-selected="false"
                    role="tab"
                    onClick={(e) => setCurrentTab("activity")}
                    tabIndex={-1}
                  >
                    Activity
                  </Link>
                </li>
              ) : (
                ""
              )}
            </ul>
          </div>
          <div className="card-body p-0 ">
            <div className="separator separator-dashed my-5 mt-0" />
            <div className="tab-content" id="myTV4593013ontent">
              {currenTab === "details" && (
                <div
                  className="tab-pane fade show active"
                  id="kt_tab_pane_details"
                  role="tabpanel"
                >
                  <div className="table-responsive mb-4 mt-0 m-4">
                    <div
                      id="DataTables_Table_0_wrapper"
                      className="dataTables_wrapper dt-bootstrap4 no-footer"
                    >
                      <div className="table-responsive">
                        {isLoading && (
                          <div className="text-center mt-2">
                            <div className="spinner-border h-50px w-50px text-gray-400" />
                          </div>
                        )}
                        {!isLoading && (
                          <table
                            className="table chart-detail-table table-rounded mb-5 gs-8 gy-5 table-row-dashed fs-6 mb-0 nowrap dataTable no-footer"
                            id="DataTables_Table_0"
                          >
                            <thead>
                              <tr className=" border-bottom fw-bold fs-7 text-uppercase gs-0">
                                <th
                                  className="min-w-175px pb-2 align-middle sorting"
                                  tabIndex={0}
                                  aria-controls="DataTables_Table_0"
                                  rowSpan={1}
                                  colSpan={1}
                                  aria-label="Progress : activate to sort column ascending"
                                  style={{ width: "179.021px" }}
                                >
                                  Progress{" "}
                                  <OverlayTrigger
                                    key={"right"}
                                    placement={"top"}
                                    overlay={
                                      <Tooltip id="tooltip-right">
                                        Charts completed / Total volume * 100
                                      </Tooltip>
                                    }
                                  >
                                    <i className="fas fa-exclamation-circle ms-2 fs-7" />
                                  </OverlayTrigger>
                                </th>
                                <th
                                  className="min-w-60px pb-2 align-middle sorting"
                                  tabIndex={0}
                                  aria-controls="DataTables_Table_0"
                                  rowSpan={1}
                                  colSpan={1}
                                  aria-label="Ready to  Code : activate to sort column ascending"
                                  style={{ width: 62 }}
                                >
                                  Ready to <br /> Code
                                </th>
                                <th
                                  className="min-w-60px pb-2 align-middle sorting"
                                  tabIndex={0}
                                  aria-controls="DataTables_Table_0"
                                  rowSpan={1}
                                  colSpan={1}
                                  aria-label="Coding in progress: activate to sort column ascending"
                                  style={{ width: 60 }}
                                >
                                  Coding in
                                  <br /> progress
                                </th>
                                <th
                                  className="min-w-60px pb-2 align-middle sorting"
                                  tabIndex={0}
                                  aria-controls="DataTables_Table_0"
                                  rowSpan={1}
                                  colSpan={1}
                                  aria-label="Coding  Done : activate to sort column ascending"
                                  style={{ width: 60 }}
                                >
                                  Coding <br /> Done
                                </th>
                                <th
                                  className="min-w-60px pb-2 align-middle sorting"
                                  tabIndex={0}
                                  aria-controls="DataTables_Table_0"
                                  rowSpan={1}
                                  colSpan={1}
                                  aria-label="Ready to  Audit : activate to sort column ascending"
                                  style={{ width: 62 }}
                                >
                                  Ready to <br /> Audit
                                </th>
                                <th
                                  className="min-w-60px pb-2 align-middle sorting"
                                  tabIndex={0}
                                  aria-controls="DataTables_Table_0"
                                  rowSpan={1}
                                  colSpan={1}
                                  aria-label="Audit in progress: activate to sort column ascending"
                                  style={{ width: 60 }}
                                >
                                  Audit in
                                  <br /> progress
                                </th>
                                <th
                                  className="min-w-60px pb-2 align-middle sorting"
                                  tabIndex={0}
                                  aria-controls="DataTables_Table_0"
                                  rowSpan={1}
                                  colSpan={1}
                                  aria-label="Audit  Done: activate to sort column ascending"
                                  style={{ width: 60 }}
                                >
                                  Audit <br /> Done
                                </th>
                                <th
                                  className="min-w-90px pb-2 align-middle sorting"
                                  tabIndex={0}
                                  aria-controls="DataTables_Table_0"
                                  rowSpan={1}
                                  colSpan={1}
                                  aria-label="Reallocate: activate to sort column ascending"
                                  style={{ width: "107.708px" }}
                                >
                                  Reallocate
                                </th>
                                {(localStorage.getItem("Role") ===
                                  userRole.Manager ||
                                  localStorage.getItem("Role") ===
                                    userRole.TL ||
                                  (localStorage.getItem("Role") ===
                                    userRole.Auditor &&
                                    isAuditor)) && (
                                  <th
                                    className="min-w-90px pb-2 align-middle sorting"
                                    tabIndex={0}
                                    aria-controls="DataTables_Table_0"
                                    rowSpan={1}
                                    colSpan={1}
                                    aria-label="Chart List: activate to sort column ascending"
                                    style={{ width: "107.708px" }}
                                  >
                                    {" "}
                                    Chart List{" "}
                                  </th>
                                )}
                              </tr>
                            </thead>
                            <tbody className="text-gray-600 fw-semibold">
                              {worklistRows?.map((item, index) => (
                                <tr key={index} className="odd">
                                  <td className="align-middle">
                                    <div className="vis-item-overflow">
                                      <div
                                        className="vis-item-content"
                                        style={{ transform: "translateX(0px)" }}
                                      >
                                        <div className="rounded-pill bs-green-light d-flex align-items-center position-relative h-40px w-100 p-2 overflow-hidden">
                                          <div
                                            className="position-absolute rounded-pill d-block start-0 top-0 h-100 z-index-1"
                                            style={{
                                              width: `${item?.progress_percentage}%`,
                                              backgroundColor: `rgb(0,${
                                                220 - item?.progress_percentage
                                              },0)`,
                                            }}
                                          />
                                          <div className="d-flex align-items-center position-relative z-index-2">
                                            <div className="symbol-group symbol-hover flex-nowrap me-3">
                                              {item?.users?.length > 0 ? (
                                                item?.users?.map((user) => (
                                                  <div
                                                    key={user.id}
                                                    className="symbol symbol-circle symbol-25px"
                                                    data-bs-toggle="tooltip"
                                                    data-bs-original-title=""
                                                    data-kt-initialized={1}
                                                  >
                                                    <OverlayTrigger
                                                      overlay={
                                                        <Tooltip>
                                                          {user?.name}
                                                        </Tooltip>
                                                      }
                                                      key={"right"}
                                                      placement={"top"}
                                                    >
                                                      <img
                                                        alt={user?.name}
                                                        src={
                                                          user?.image_url ??
                                                          `../assets/media/avatars/300-${imageIdGenerate(
                                                            user?.id,
                                                          )}.jpg`
                                                        }
                                                      />
                                                    </OverlayTrigger>
                                                  </div>
                                                ))
                                              ) : (
                                                <div
                                                  className="symbol symbol-circle symbol-25px"
                                                  data-bs-toggle="tooltip"
                                                  data-bs-original-title="Amit Kumar (Coder)"
                                                  data-kt-initialized={1}
                                                >
                                                  <img
                                                    alt="Unallocated"
                                                    title="Unallocated"
                                                    src="../assets/media/avatars/blank.svg"
                                                  />
                                                </div>
                                              )}
                                            </div>
                                            <span className="fw-bold text-dark text-hover-dark">
                                              {item?.range}
                                            </span>
                                          </div>
                                          <div className="d-flex flex-center bg-body rounded-pill fs-7 fw-bolder ms-auto h-100 px-3 position-relative z-index-2">
                                            {item?.progress_percentage} %
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                  <td className="align-middle">
                                    {item?.ready_to_code_count}
                                  </td>
                                  <td className="align-middle">
                                    {item?.coding_progress_count}
                                  </td>
                                  <td className="align-middle">
                                    {item?.coding_done_count}
                                  </td>
                                  <td className="align-middle">
                                    {item?.ready_to_audit_count}
                                  </td>
                                  <td className="align-middle">
                                    {item?.audit_progress_count}
                                  </td>
                                  <td className="align-middle">
                                    {item?.audit_done_count}
                                  </td>
                                  <td className="align-middle text-center">
                                    {item?.progress_percentage !== "100.00" &&
                                      item?.ready_to_code_count > 0 && (
                                        <span
                                          onClick={(e) => {
                                            setShowModalBox(true);
                                            setRangeWorklist(item?.range);
                                          }}
                                        >
                                          <span
                                            className="svg-icon svg-icon-primary svg-icon-2hx"
                                            title="Reallocate"
                                            style={{ cursor: "pointer" }}
                                          >
                                            <svg
                                              width={30}
                                              height={30}
                                              viewBox="0 0 30 30"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path
                                                opacity="0.3"
                                                d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z"
                                                fill="currentColor"
                                              />
                                              <path
                                                d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z"
                                                fill="currentColor"
                                              />
                                              <path
                                                d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z"
                                                fill="currentColor"
                                              />
                                            </svg>
                                          </span>
                                        </span>
                                      )}
                                  </td>
                                  <td className="align-middle">
                                    {item?.users?.length !== 0 &&
                                      (localStorage.getItem("Role") ===
                                        userRole.Manager ||
                                        localStorage.getItem("Role") ===
                                          userRole.TL ||
                                        (localStorage.getItem("Role") ===
                                          userRole.Auditor &&
                                          isAuditor)) && (
                                        <span
                                          style={{
                                            cursor: "pointer",
                                            marginLeft: "2vw",
                                          }}
                                          onClick={(e) =>
                                            handleRedirect(item?.range)
                                          }
                                        >
                                          <span
                                            className="svg-icon svg-icon-primary svg-icon-2hx"
                                            data-bs-toggle="tooltip"
                                            data-bs-placement="top"
                                            title="Details"
                                          >
                                            <svg
                                              width={30}
                                              height={30}
                                              title="Details"
                                              viewBox="0 0 30 30"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path
                                                d="M15.43 8.56949L10.744 15.1395C10.6422 15.282 10.5804 15.4492 10.5651 15.6236C10.5498 15.7981 10.5815 15.9734 10.657 16.1315L13.194 21.4425C13.2737 21.6097 13.3991 21.751 13.5557 21.8499C13.7123 21.9488 13.8938 22.0014 14.079 22.0015H14.117C14.3087 21.9941 14.4941 21.9307 14.6502 21.8191C14.8062 21.7075 14.9261 21.5526 14.995 21.3735L21.933 3.33649C22.0011 3.15918 22.0164 2.96594 21.977 2.78013C21.9376 2.59432 21.8452 2.4239 21.711 2.28949L15.43 8.56949Z"
                                                fill="currentColor"
                                              />
                                              <path
                                                opacity="0.3"
                                                d="M20.664 2.06648L2.62602 9.00148C2.44768 9.07085 2.29348 9.19082 2.1824 9.34663C2.07131 9.50244 2.00818 9.68731 2.00074 9.87853C1.99331 10.0697 2.04189 10.259 2.14054 10.4229C2.23919 10.5869 2.38359 10.7185 2.55601 10.8015L7.86601 13.3365C8.02383 13.4126 8.19925 13.4448 8.37382 13.4297C8.54839 13.4145 8.71565 13.3526 8.85801 13.2505L15.43 8.56548L21.711 2.28448C21.5762 2.15096 21.4055 2.05932 21.2198 2.02064C21.034 1.98196 20.8409 1.99788 20.664 2.06648Z"
                                                fill="currentColor"
                                              />
                                            </svg>
                                          </span>
                                        </span>
                                      )}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        )}
                      </div>
                      <div className="row">
                        <div className="col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" />
                        <div className="col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {currenTab === "activity" && Object.keys(activityLog).length !== 0
                ? activityLog?.map((item, index) => (
                    <div
                      key={index}
                      className="tab-pane fade show active"
                      id="kt_tab_pane_activity"
                      role="tabpanel"
                    >
                      <div className="ms-5" style={{ paddingLeft: "2rem" }}>
                        <div className="timeline">
                          <div className="timeline-item">
                            <div className="timeline-line w-20px" />
                            <div className="timeline-icon symbol symbol-circle symbol-20px">
                              <div className="symbol-label bg-light">
                                <i className="fa-solid fa-circle-dot fs-9" />
                              </div>
                            </div>
                            <div className="timeline-content">
                              <div className="pe-3 mb-0">
                                <div className="fs-5 fw-semibold mb-0">
                                  {item?.activityText}
                                </div>
                                <div className="overflow-auto pb-0">
                                  <div className="d-flex flex-stack align-items-center mt-0 fs-6">
                                    <div className="text-muted me-2 fs-7">
                                      {item?.activityTime &&
                                        moment(item?.activityTime)
                                          .format("MM/DD/YYYY hh:mm:ss a BZ")
                                          .replace("B", "GMT") + " by "}{" "}
                                      <span className="text-primary">
                                        {item?.activityBy}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                : currenTab === "activity" && (
                    <div className="ms-5 mb-5 text-center">
                      No activities found
                    </div>
                  )}
            </div>
          </div>
        </div>
      </div>
      {showModalBox && (
        <WorklistModal
          changeInWorklist={changeInWorklist}
          setChangeInWorklist={setChangeInWorklist}
          worklistId={worklistId}
          handleActivityModal={handleActivityModal}
          showModalBox={showModalBox}
          masterData={masterData}
          handleParentWorklist={handleParentWorklist}
          rangeWorklist={rangeWorklist}
        />
      )}
    </>
  );
}
export default WorklistDetailsActivity;
